import { head, filter, join, map } from 'lodash';

/**
 * Returns formatted name from composer object
 *
 * @param {Object} composer
 * @returns {string}
 */
export const getComposerName = (composer = {}) => {
  const { first_name: first, last_name: last, name } = composer;
  if (first && last) {
    return `${first} ${last}`;
  }
  return name || '';
};

/**
 * Returns formatted name from creators array
 *
 * @param {Array} creators
 * @returns {string}
 */
export const getComposerNamesFromCreators = (creators = []) => {
  const composers = filter(creators, creator => creator?.profession?.slug === 'composer');

  return join(map(composers, 'profile.name'), ' ,');
};

/**
 * Returns formatted name from creators array
 *
 * @param {Array} creators
 * @returns {string}
 */
export const getComposersFromCreators = (creators = []) => {
  const composers = filter(creators, creator => creator?.profession?.slug === 'composer');

  return composers;
};

/**
 * Returns formatted name from creators array
 *
 * @param {Array} creators
 * @returns {string}
 */
export const getComposerFromCreators = (creators = []) => {
  const composers = filter(creators, creator => creator?.profession?.slug === 'composer');

  return head(composers);
};
